import { useContext } from 'react';

// auth provider
import { useSelector } from "react-redux";
// import AuthContext from 'contexts/Auth0Context';
// import AuthContext from 'contexts/JWTContext';
// import AuthContext from 'contexts/AWSCognitoContext';

// ==============================|| AUTH HOOKS ||============================== //

const useAuth = () => {
    const auth = useSelector((state) => state.auth);

   

    return auth;
};

export default useAuth;
